import React, { memo } from 'react';

import SweepsLogo from '@/assets/icons/sweepsLogo';
import { SocialCurrencyToggle } from '@/components/SocialCurrencyToggle';
import { SocialWalletBalanceButton } from '@/components/SocialWalletBalanceButton';
import { Row } from '@/components/lib/components';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';

export const SweepsHeader = memo(() => (
    <MaxWidthWrapper>
        <Row justifyContent="space-between" px="s16" alignItems="center" height={48}>
            <SweepsLogo />
            <Row gap="s8">
                <SocialWalletBalanceButton />
                <SocialCurrencyToggle />
            </Row>
        </Row>
    </MaxWidthWrapper>
));
